import { useEffect, useState } from 'react';

import { useRouter } from 'next/router';

import { isBrowserEnv } from 'modules/common/utils/env';

export const useFiltersQuery = () => {
  const router = useRouter();
  const [filtersToken, setFiltersToken] = useState('');
  const handleRouteChanged = () => {
    if (isBrowserEnv()) {
      setFiltersToken(window.location.href);
    }
  };

  useEffect(() => {
    router.events.on('routeChangeComplete', handleRouteChanged);
    return () => {
      router.events.off('routeChangeComplete', handleRouteChanged);
    };
  }, [router.events]);

  return {
    filters: router.query as {
      [x: string]: string;
    },
    filtersToken: filtersToken + router.isReady,
    filtersQueryIsLoading: !router.isReady,
  };
};
